<template>
  <div>
    <!-- 商品导航 轮播图 -->
    <div class="nav-banner clearfloat">
      <div class="w">
        <!-- 商品导航 S -->
        <div class="goods-nav fl">
          <ul>
            <li v-for="(item, index) in lists" :key="index" @click="classify(item.name_jp)"
              @mouseover="getSecond(item.childs)">
              <router-link to="/">{{ item.name_jp }}</router-link>
            </li>
          </ul>
          <div class="goods-class-nav">
            <div class="class-nav">
              <span v-for="(item, index) in secondlist" :key="index" @click="classify(item.name_jp)">{{ item.name_jp
                }}</span>
            </div>
          </div>
        </div>
        <!-- 商品导航 E-->
        <!-- 轮播图 S -->
        <div class="banner fl">
          <el-carousel trigger="click" class="bannerbox" :interval="5000">
            <el-carousel-item v-for="item in bannerlist" :key="item.index">
              <a :href="item.url" v-if="item.url" target="_blank">
                <img :src="item.pic" alt />
              </a>
              <img :src="item.pic" alt v-else />
            </el-carousel-item>
          </el-carousel>
        </div>
        <!-- 轮播图 E -->
      </div>
      <div class="enquiry-box fl">
        <!-- 登录框 -->
        <div class="login-box" v-if="userInfo">
          <router-link to="/user/index">
            <div class="user-img fl">
              <img src="../../assets/img/user.png" v-if="userInfo.data.pic ==
              'http://www.rakumart-2c.com/upload/avatar.png'
              " alt />
              <img :src="userInfo.data.pic" v-else alt />
            </div>
            <p>{{ userInfo.data.ddusername }}</p>
          </router-link>
        </div>
        <div class="login-box" v-else>
          <div class="user-img fl">
            <img src="../../assets/img/user.png" alt />
          </div>
          <div class="login fl">
            <router-link to="/register" style="background: #f3c622; color: #fff; border: 0">会員登録</router-link>
            <router-link to="/login" style="margin-top: 10px">ログイン</router-link>
          </div>
        </div>
        <!-- 公告 -->
        <div class="notice">
          <h3>お知らせ</h3>
          <ul>
            <li v-for="item in noticelist" :key="item.id">
              <img src="../../assets/img/_TZ-.png" alt="" v-show="item.show" />
              <router-link :to="{
              name: 'notice',
              query: {
                title: item.title,
                datetime: item.datetime,
                Message: item.Message,
              },
            }" target="_blank">{{ item.title }}{{ item.title }}</router-link>
            </li>
          </ul>
          <button>もっと見る</button>
        </div>
      </div>
    </div>
    <!-- mian -->
    <div class="mian w">
      <!-- 商品推荐 -->
      <hotSaleProducts />
      <!-- <div class="mian-list">
        <h3>
          <img src="../../assets/img/形状 1.png" alt />
          <span>お勧め</span>
          <img src="../../assets/img/形状 2.png" alt />
        </h3>
        <el-carousel trigger="click" :interval="5000">
          <el-carousel-item v-for="item in recommendlist" :key="item.index">
            <div
              class="mian-item"
              v-for="(item1, index1) in item"
              :key="index1"
              @click="getSearchGoodsList(item1.product_item_id)"
            >
              <div class="mian-item-img">
                <img :src="item1.image" alt />
              </div>
              <span>￥{{ item1.price_pifa }}</span>
              <span style="color: #f3c622; margin-left: 30px"
                >{{ Math.ceil(item1.price_pifa * exchangeRate) }}(円)</span
              >
              <p>{{ item1.title_japanese }}</p>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div> -->
      <!-- 首页产品分类  -->
      <div class="mian-list" v-for="(item, index) in productlist" :key="index">
        <h3>
          <img src="../../assets/img/形状 1.png" alt />
          <span>{{ item.name_jp }}</span>
          <img src="../../assets/img/形状 2.png" alt />
        </h3>
        <ul class="mian-nav">
          <li v-for="(item1, index1) in item.childs" :key="index1"
            @mouseover="getChildClass(index, index1, item1.product)"
            :class="{ choose: isChoose[index].isChoose == index1 }" @click="classify(item1.cid)">
            {{ item1.name_jp }}
          </li>
        </ul>
        <div class="mian-item" v-for="(item2, index2) in classlist[index]" :key="index2"
          @click="getSearchGoodsList(item2.product_item_id)">
          <div class="mian-item-img">
            <el-image :src="item2.image">
              <div slot="placeholder" class="image-slot">
                <i class="el-icon-loading"></i>
              </div>
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
          <span>￥{{ item2.price_pifa }}</span>
          <span style="color: #f3c622; margin-left: 30px">{{ Math.ceil(item2.price_pifa * exchangeRate) }}(円)</span>
          <p :title="item2.title_japanese">{{ item2.title_japanese }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import {
  categoryLlist,
  mainProductList,
  getNavList,
  getSecond,
  getBannerList,
  getNoticeList,
  getRecommendList,
  getClass,
  getProductList,
} from "../../api/API/home";
import hotSaleProducts from './hotSaleProducts.vue'
export default {
  metaInfo: {
    title: "Rakumart無在庫トップページ",
    meta: [
      {
        name: "discription",
        content: "一年卖出三千亿条内裤，裤衩可以绕地球八圈",
      },
      { name: "keywords", content: "作品展,品牌展,广告设计展" },
    ],
  },
  components: {
    hotSaleProducts
  },
  data() {
    return {
      lists: [], //全部分类
      navlist: [], // 一级主分类
      secondlist: [], // 二级分类
      bannerlist: [], // banner
      noticelist: [], // 公告
      productlist: [], // 首页产品分类
      recommendlist: [], // 推荐
      classlist: [], // 首页产品分类
      isChoose: [],
      userinfo: null,
    };
  },
  created() {
    this.categoryLlist();
  },
  computed: {
    // 登入状态
    ...mapState(["userInfo", "exchangeRate"]),
  },
  methods: {
    ...mapMutations(["particulars", "searchResult"]),
    //全部分类
    categoryLlist() {
      categoryLlist().then((res) => {
        this.lists = res.data;
        this.getBannerList();
        this.getNoticeList();
        this.getRecommendList();
      });
      mainProductList().then((res) => {
        this.productlist = res.data;
        for (var i = 0; i < this.productlist.length; i++) {
          this.classlist[i] = this.productlist[i].childs[0].product;
          this.isChoose.push({ isChoose: 0 });
        }
      });
    },
    // 二级导航
    getSecond(item) {
      this.secondlist = item;
    },
    // banner
    getBannerList() {
      var list = {
        mod: "inc",
        act: "ordersys",
        str: "getBanner",
      };
      getBannerList(list).then((res) => {
        this.bannerlist = res.data;
      });
    },
    // 公告
    getNoticeList() {
      var list = {
        mod: "inc",
        act: "ordersys",
        str: "getMessages",
        token: localStorage.getItem("token"),
      };
      let date = new Date().getTime();

      getNoticeList(list).then((res) => {
        this.noticelist = res.data;
        let qitianTime = 24 * 7 * 60 * 60 * 1000;
        this.noticelist.forEach((item) => {
          item.newTime = this.dateToTimestamp(item.datetime) + qitianTime;

          if (item.newTime - date >= 0) {
            item.show = true;
          } else {
            item.show = false;
          }
        });
      });
    },
    dateToTimestamp(dateStr) {
      if (!dateStr) {
        return "";
      }
      let newDataStr = dateStr.replace(/\.|\-/g, "/");
      let date = new Date(newDataStr);
      let timestamp = date.getTime();
      return timestamp;
    },
    // 推荐
    getRecommendList() {
      getRecommendList().then((res) => {
        this.recommendlist = res.data;
      });
    },
    //商品跳转
    getSearchGoodsList(id, iid, type) {
      console.log(id);
      if (id != undefined) {
        let routeUrl = this.$router.resolve({
          path: "/details?id=" + id,
        });
        window.open(routeUrl.href, "_blank");
      } else {
        let routeUrl = this.$router.resolve({
          path: "/details1688?iid=" + iid + "&type=" + type,
        });
        window.open(routeUrl.href, "_blank");
      }
    },
    // 商品切换
    getChildClass(index, index1, item) {
      this.isChoose[index].isChoose = index1;
      this.classlist[index] = item;
    },
    // 关键字跳转
    search(name) {
      this.searchResult(name);
      let routeUrl = this.$router.resolve({
        path: "/list",
      });
      window.open(routeUrl.href, "_blank");
    },
    // 分类
    classify(name) {
      this.searchResult("");
      let routeUrl = this.$router.resolve({
        path: "/list1688?type=taobao&result=" + name,
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>
<style lang='scss' scoped>
@import "../../css/home.scss";
</style>